var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineListCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15H25V17H19V15ZM19 19H25V21H19V19ZM19 23H25V25H19V23ZM15 15H17V17H15V15ZM15 19H17V21H15V19ZM15 23H17V25H15V23ZM28.1 11H11.9C11.4 11 11 11.4 11 11.9V28.1C11 28.5 11.4 29 11.9 29H28.1C28.5 29 29 28.5 29 28.1V11.9C29 11.4 28.5 11 28.1 11ZM27 27H13V13H27V27Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineListCircle40Px);
export default __webpack_public_path__ + "static/media/ic_outline-list_circle-40px.394ec8a5f6a3b547cfb079b159f5d88c.svg";
export { ForwardRef as ReactComponent };